export const JERKYS = [
  {
    id: 0,
    name: "Louisville Vegan Jerky Co.",
    image: "/veganjdm/static/media/louisville_header.26b880c7.jpg",
    textureimage: "/veganjdm/static/media/louisville_texture.ec57fbee.jpg",
    rank: 1,
    flavor: "Smoked Black Pepper",
    taste: 9,
    texture: 8,
    chew: 8,
    total: 25,
    construction: "Textured Soy Protein",
    notes:
      "This jerky has the best balance of that smokey, spicy flavor you expect in a black pepper jerky. The texure and chew is a little soft for me but it does remind me of a fresh thick cut style beef jerky. I like to eat it with a handful of peanuts. Overall Louisville Vegan Jerky is the best vegan jerky I've tasted, I also like the Smokey Carolina BBQ flavor. The Perfect Pepperoni didn't really impress me, but I do want to try it on a pizza and give it another shot. UPDATE 2/20/21: I made a pizza and put the Perfect Pepperoni on it. It did have the proper pepporoni flavor if you can get your mind to accept the shape and texture difference. Next time I will put the pepperoni on half way through baking as the pieces that were up high got a little crispy.",
  },
  {
    id: 1,
    name: "Primal Spirit Foods Primal Strips",
    image: "/veganjdm/static/media/primal_spirit_header.a0e1a247.jpg",
    textureimage: "/veganjdm/static/media/primal_spirit_texture.289ed597.jpg",
    rank: 3,
    flavor: "Teriyaki",
    taste: 6,
    texture: 8,
    chew: 10,
    total: 24,
    construction: "Seitan",
    notes:
      "The chew on this stuff is amazing. It feels almost too real, I had to look at it several times to be sure this wasn't real beef. The Thai Peanut and Teriyaki I tried were seitan based while the Texas BBQ was soy based. I was surprised to get nearly the same texture and chew from the soy based strips. They've got a great base here, and I will buy it again, the flavors just need some fine tuning. I'm missing that smokey flavor.",
  },
  {
    id: 2,
    name: "Solely: Organic Fruit Jerky",
    image: "/veganjdm/static/media/solely_header.115a7291.jpg",
    textureimage: "/veganjdm/static/media/solely_texture.0e84a648.jpg",
    rank: 4,
    flavor: "Pineapple with Chili & Salt",
    taste: 10,
    texture: 7,
    chew: 6,
    total: 23,
    construction: "Fruit",
    notes:
      "This stuff is awesome. I thought there was no way this could classify as a jerky when I first picked it up. But they've pulled it off. It appears they've just taken fruit and pressed it in to a stick form. The moisture level is perfect, not too dry like fruit leather, but just right to give it a jerky quality. The texture and chew is a liitle soft as you would expect from a fruit based product. The pineapple and mango flavors are all delicious. The banana and pecan reminded me of banana bread and I wasn't that impressed by the other banana flavors but I'm not really in to bananas. I call these flavors, but the cool thing about this product is it is just compressed fruit and some spices or nuts. You can buy it at the gas station and feel good about eating it. I ordered a sample pack on Amazon to get the Pineapple Chili & Salt as I could not find it in stores. It reminds me of a spicy pineapple margarita, which gives me an idea. I'm gonna have to put one of these in a glass of vodka and see what happens.",
  },
  {
    id: 3,
    name: "Sweet Earth Kung-Pao Plant-Based Jerky",
    image: "/veganjdm/static/media/sweet_earth_header.0e42f204.jpg",
    textureimage: "/veganjdm/static/media/sweet_earth_texture.be6b5d0f.jpg",
    rank: 6,
    flavor: "Spicy Kung-Pao",
    taste: 7,
    texture: 4,
    chew: 6,
    total: 17,
    construction: "Seitan",
    notes:
      "While I loved the spicy Kung-Pao flavor, that was all that impressed with this jerky. This is the second bag I've bought and it will probably be the last. The texture is what I would describe as shiny-chunky. Kind of reminds me of the old Lowry beef strips that came in the cardboard tube individually wrapped. I didn't really like those either, but I would eat the whole tube. It has that quality that you don't really like while you're eating it. But when you get done and you have the salty after taste on the sides of your tounge, you wanna try it again, only to be disappointed again. A vicious cycle. This flavor on a primal strip would be a winner. Unfortunately the texture just doesn't deliver on this one.",
  },
  {
    id: 4,
    name: "Foreal Foods Coconut Jerky",
    image: "/veganjdm/static/media/foreal_header.680722cf.jpg",
    textureimage: "/veganjdm/static/media/foreal_texture.280eadc0.jpg",
    rank: 7,
    flavor: "Original Peppered",
    taste: 2,
    texture: 3,
    chew: 3,
    total: 8,
    construction: "Coconut",
    notes:
      "I really wanted to like this jerky. They have a great idea, making jerky(and other things) out of the left over coconut meat from making coconut water. The first bite was not a good experience. I got a thin piece that was hard as a rock, and the initial taste was not a good one. I seriously considered stopping there. But I read the bag again and I really liked what they are doing. The flavor gets better once you get past the initial shock. If you get a thicker piece the texture and chew is actually quite good. Part of their upcycling philosophy is to use all the parts. Unfortunately the thinner pieces are just unpleasant to chew. I'm gonna try this one again if I see it in a store. Sometimes with vegan jerky you have to give it second chance. It's a great concept and I hope the next bag proves me wrong. UPDATE: Tried another bag, Chili Lime this time. While the experience was better, the result was the same. This bag had a better starting flavor and the thickness of the pieces was better. I didn't get any thin/hard pieces this time. I just don't like the way the coconut flavor takes over while you are chewing it. If you're a big coconut fan this might be up your alley. For me, its got a sunscreen aftertaste that I just can't get behind. I haven't written it off yet and I may try it again.",
  },
  {
    id: 5,
    name: "Far West Fungi Mushroom Jerky",
    image: "/veganjdm/static/media/farwestfungi_header.17a268c6.jpg",
    textureimage: "/veganjdm/static/media/farwestfungi_texture.f3ac1344.jpg",
    rank: 2,
    flavor: "Spicy Tree Oyster",
    taste: 8,
    texture: 7,
    chew: 10,
    total: 25,
    construction: "Tree Oyster Mushrooms",
    notes:
      "Eat it off the floor good. Thats right I dropped a piece on the floor and still ate it. This has the look and chew of actual beef jerky. That pick it out of your teeth real jerky style. The salty, balsamic flavor is awesome with the red pepper flakes adding just the right amount of heat. It doesn't have a strong mushroom flavor, only a hint in the after taste. Speaking of after taste, the salty, umami goodness had me licking my lips and teeth as I reached for another handful. The only downside to this jerky is the small pieces and my wife hates mushrooms so this can't be a family treat in my house. The shiitake peppered version is a little meatier with more of a mushroom taste and a little less heat. ",
  },
  {
    id: 6,
    name: "Perky Jerky Plant-Based Jerky",
    image: "/veganjdm/static/media/perkyjerky_header.df3aa083.jpg",
    textureimage: "/veganjdm/static/media/perkyjerky_texture.ac19fa99.jpg",
    rank: 5,
    flavor: "Tasty Teriyaki",
    taste: 7,
    texture: 7,
    chew: 7,
    total: 21,
    construction: "Soy Powder",
    notes:
      "This jerky scored triple 7's. A real middle of the road for me. The chew and texture wasn't bad, a little soft but that's better than too hard. The flavor is a sweet teriyaki. I can hear the pineapple and brown sugar with a little ginger kick. Overall a little too sweet for my tastes. Not a bad go at vegan jerky from what appears to be a more meat focused company. I would eat it again and I think this would be good for those trying to transition to a plant based lifestyle. I would call it a shoulder shrug emoji, could take it or leave it.",
  },
];
